/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './user-password.component.css.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../shared/ui/mobile-header/mobile-header.component.ngfactory';
import * as import3 from '../../../../app/shared/ui/mobile-header/mobile-header.component';
import * as import4 from '@angular/router';
import * as import5 from '../../../../app/booking-management/booking-header/booking-header.service';
import * as import6 from '../user-header/user-header.component.ngfactory';
import * as import7 from '../../../../app/user-management/user-header/user-header.component';
import * as import8 from '../../../../app/shared/router/linkhelper';
import * as import9 from '@angular/material';
import * as import10 from './user-password-form/user-password-form.component.ngfactory';
import * as import11 from '../../../../app/user-management/user-password/user-password-form/user-password-form.component';
import * as import12 from '../../../../app/api/user.service';
import * as import13 from '../../../../app/notification/notification.service';
import * as import14 from '../../../../app/spinner/spinner.service';
import * as import15 from '../../../../app/user-management/user-password/user-password.component';
const styles_UserPasswordComponent:any[] = [import0.styles];
export const RenderType_UserPasswordComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_UserPasswordComponent,
  data: {}
}
);
export function View_UserPasswordComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-mobile-header',[
      [
        'backLink',
        '/user-management/profile'
      ]
      ,
      [
        'title',
        'CHANGE PASSWORD'
      ]

    ]
    ,(null as any),(null as any),(null as any),import2.View_MobileHeaderComponent_0,import2.RenderType_MobileHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import3.MobileHeaderComponent,[
      import4.Router,
      import5.BookingHeaderService
    ]
    ,{
      title: [
        0,
        'title'
      ]
      ,
      backLink: [
        1,
        'backLink'
      ]
      ,
      showBackLink: [
        2,
        'showBackLink'
      ]

    }
    ,(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),5,'section',[[
        'id',
        'submenu'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(16777216,(null as any),(null as any),2,'app-user-header',[[
        'id',
        'main-submenu-links'
      ]
    ],(null as any),(null as any),(null as any),import6.View_UserHeaderComponent_0,import6.RenderType_UserHeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import7.UserHeaderComponent,[
      import8.LinkAuth,
      import4.Router,
      import9.MdDialog,
      import1.ViewContainerRef
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),[' '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n'])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),7,'div',[[
        'id',
        'page-common'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'main',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-user-password-form',([] as any[]),(null as any),(null as any),(null as any),import10.View_UserPasswordFormComponent_0,import10.RenderType_UserPasswordFormComponent)),
    import1.ɵdid(49152,(null as any),0,import11.UserPasswordFormComponent,[
      import12.UserService,
      import13.NotificationServiceBus,
      import14.SpinnerService,
      import4.ActivatedRoute
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_0:any = 'CHANGE PASSWORD';
    const currVal_1:any = '/user-management/profile';
    const currVal_2:any = true;
    ck(v,1,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_UserPasswordComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'app-user-password',([] as any[]),(null as any),(null as any),(null as any),View_UserPasswordComponent_0,RenderType_UserPasswordComponent)),
    import1.ɵdid(49152,(null as any),0,import15.UserPasswordComponent,([] as any[]),(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const UserPasswordComponentNgFactory:import1.ComponentFactory<import15.UserPasswordComponent> = import1.ɵccf('app-user-password',import15.UserPasswordComponent,View_UserPasswordComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC91c2VyLW1hbmFnZW1lbnQvdXNlci1wYXNzd29yZC91c2VyLXBhc3N3b3JkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvdXNlci1tYW5hZ2VtZW50L3VzZXItcGFzc3dvcmQvdXNlci1wYXNzd29yZC5jb21wb25lbnQudHMiLCJuZzovLy92ZXJjZWwvd29ya3BhdGgwL3NyYy9hcHAvdXNlci1tYW5hZ2VtZW50L3VzZXItcGFzc3dvcmQvdXNlci1wYXNzd29yZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC91c2VyLW1hbmFnZW1lbnQvdXNlci1wYXNzd29yZC91c2VyLXBhc3N3b3JkLmNvbXBvbmVudC50cy5Vc2VyUGFzc3dvcmRDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8YXBwLW1vYmlsZS1oZWFkZXJcbiAgdGl0bGU9XCJDSEFOR0UgUEFTU1dPUkRcIlxuICBbc2hvd0JhY2tMaW5rXT1cInRydWVcIlxuICBiYWNrTGluaz1cIi91c2VyLW1hbmFnZW1lbnQvcHJvZmlsZVwiXG4+PC9hcHAtbW9iaWxlLWhlYWRlcj5cblxuPHNlY3Rpb24gaWQ9XCJzdWJtZW51XCI+XG4gIDxhcHAtdXNlci1oZWFkZXIgaWQ9XCJtYWluLXN1Ym1lbnUtbGlua3NcIj4gPC9hcHAtdXNlci1oZWFkZXI+XG48L3NlY3Rpb24+XG5cbjxkaXYgaWQ9XCJwYWdlLWNvbW1vblwiPlxuICA8bWFpbj5cbiAgICA8YXBwLXVzZXItcGFzc3dvcmQtZm9ybT48L2FwcC11c2VyLXBhc3N3b3JkLWZvcm0+XG4gIDwvbWFpbj5cbjwvZGl2PlxuIiwiPGFwcC11c2VyLXBhc3N3b3JkPjwvYXBwLXVzZXItcGFzc3dvcmQ+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lDQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO2dCQUFBOzs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtJQUlxQjtNQUVyQjtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXNCO01BQ3BCO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTtJQUF5QztJQUFtQjtJQUNwRDtNQUVWO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBc0I7SUFDcEI7SUFBTTtJQUNKO2dCQUFBOzs7OztJQUFBO0tBQUE7SUFBaUQ7SUFDNUM7SUFDSDs7O0lBYko7SUFFQTtJQURBO0lBRkYsU0FDRSxVQUVBLFVBREEsU0FGRjs7Ozs7SUNBQTtnQkFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/user-management/user-password/user-password.component.ngfactory.ts